import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {
    DefaultShipmentTypeDto,
    DefaultShippingDestinationTypeDto,
    ShippingClientProjectionListItemDto
} from "../../api/cms";

const systemApi = api.cms.api

type ShippingClientId = string

type CmsShippingConfigDestinationConstruct = Record<DefaultShipmentTypeDto, ShippingClientId>

export type CmsShippingConfigConstruct = Record<DefaultShippingDestinationTypeDto, CmsShippingConfigDestinationConstruct>

interface OptionType { label: string, value: string }

class CmsShippingOptionStore {
    get shippingClients(): ShippingClientProjectionListItemDto[] {
        return this._shippingClients;
    }

    set shippingClients(value: ShippingClientProjectionListItemDto[]) {
        this._shippingClients = value;
    }

    get selectClientOptions(): OptionType [] {
        const result: OptionType[] = []
        result.push(...this.shippingClients.map(e => ({
            value: e.shippingClientId,
            label: e.label
        })))

        return result
    }

    private _shippingClients: ShippingClientProjectionListItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const listResult = await catchApi(async () => await systemApi.listShippingDefaultClients({
            page: 0,
            size: 200
        }))

        const listData = listResult?.data
        if (listData?.items) {
            this.shippingClients = listData.items
        } else {
            this.shippingClients = []
        }
    }
}

const cmsShippingOptionStore = new CmsShippingOptionStore()

export {
    cmsShippingOptionStore
}
